function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.3755736mm",
    height: "6.7263718mm",
    viewBox: "0 0 5.3755736 6.7263718",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.728167,-144.4307)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.560314,37.259349)",
    style: {
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 2.98108
    },
    transform: "matrix(0.67110046,0,0,0.67069462,-14.300391,52.953365)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      stroke: "#000000",
      strokeWidth: 0.394782,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 74.246209,459.62846 -23.890375,-41.37934 47.780748,0 z",
    transform: "matrix(0.1662689,0,0,0.24007608,-50.854673,-19.525664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.aa25e3d9b8c0c1349db2ba4d0bd6f713.svg";
export { ForwardRef as ReactComponent };